import { render, staticRenderFns } from "./Activos.vue?vue&type=template&id=44252946&"
import script from "./Activos.vue?vue&type=script&lang=ts&"
export * from "./Activos.vue?vue&type=script&lang=ts&"
import style0 from "./Activos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports